export { default } from './MapSectionRoomsWrapper';
